import { EnterpriseContextType, EnterpriseStateProps } from "./types";

export const defaultValues: EnterpriseContextType = {
  enterpriseState: {
    selectedEnterprise: undefined,
  },
  updateState: (_newState: Partial<EnterpriseStateProps>) => null,
};
